import React, { useState, useEffect } from 'react';
import PageWrapper from '@/components/utils/PageWrapper';
import AnimatedElement from '@/components/utils/AnimatedElement';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

const Contact = () => {
  const [isFormLoading, setIsFormLoading] = useState(true);
  
  // Function to handle form load state
  const handleFormLoad = () => {
    setIsFormLoading(false);
  };

  // Set a timeout to handle cases where the onLoad event might not fire
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFormLoading(false);
    }, 8000); // Fallback timeout after 8 seconds
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <PageWrapper
      title="Get in Touch"
      subtitle="Ready to start your AI journey? We're here to help."
    >
      <div className="container mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start max-w-5xl mx-auto">
          <div className="w-full">
          {isFormLoading && (
              <div className="flex flex-col space-y-4 h-[500px] items-center justify-center">
                <Skeleton className="w-full h-12 rounded" />
                <Skeleton className="w-full h-12 rounded" />
                <Skeleton className="w-full h-12 rounded" />
                <Skeleton className="w-full h-12 rounded" />
                <Skeleton className="w-full h-24 rounded" />
                <Skeleton className="w-32 h-10 mx-auto mt-4 rounded" />
                <p className="text-muted-foreground text-sm mt-2">Loading contact form...</p>
              </div>
            )}
            <iframe 
              aria-label='Contact Us' 
              frameBorder="0" 
              style={{ 
                height: '500px', 
                width: '100%', 
                border: 'none',
                display: isFormLoading ? 'none' : 'block'
              }} 
              src='https://forms.zohopublic.in/vijayskfict1/form/Contact/formperma/_2ypxzS2dtA7GI6F0YgWDjC6DZtf72a70YB96V5FEEA'
              onLoad={handleFormLoad}
            ></iframe>
          </div>
          
          <div className="space-y-8">
            <AnimatedElement animation="slideUp" delay={0.2}>
              <motion.div
                whileHover={{ scale: 1.02 }}
                className="glass-card p-8 md:p-10 service-card"
              >
                <h2 className="text-2xl font-semibold mb-6">Contact Information</h2>
                <div className="space-y-6">
                  <motion.div 
                    className="flex items-start"
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <MapPin className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                    <p className="text-muted-foreground">
                      7/9a Dhanam Nagar, No: 04 Veerapandi, Coimbatore-641019
                    </p>
                  </motion.div>
                  <motion.div 
                    className="flex items-center"
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <Phone className="h-5 w-5 text-primary mr-3 flex-shrink-0" />
                    <p className="text-muted-foreground">+91 9360214003</p>
                  </motion.div>
                  <motion.div 
                    className="flex items-center"
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <Mail className="h-5 w-5 text-primary mr-3 flex-shrink-0" />
                    <p className="text-muted-foreground">support@fictionalstream.zohodesk.in <span className="text-xs">(For new and existing customers)</span></p>
                  </motion.div>
                </div>
              </motion.div>
            </AnimatedElement>
            
            {/* Global Offices section - to be added later
            <AnimatedElement animation="slideUp" delay={0.4}>
              <div>
                <h2 className="text-2xl font-semibold mb-6">Global Offices</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { city: "New York", region: "Americas HQ" },
                    { city: "London", region: "European HQ" },
                    { city: "Singapore", region: "Asia-Pacific HQ" },
                    { city: "Dubai", region: "Middle East Office" }
                  ].map((office, index) => (
                    <motion.div 
                      key={index}
                      className="bg-gray-50 dark:bg-gray-800 rounded-xl p-4 service-card"
                      whileHover={{ scale: 1.05, y: -3 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <p className="font-medium">{office.city}</p>
                      <p className="text-sm text-muted-foreground">{office.region}</p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </AnimatedElement>
            */}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Contact;
